import React, { useState } from 'react';
import { toggleProductStatus, deleteProduct } from '../../services/api';
import toast from 'react-hot-toast';

const ProductDetails = ({ product, onClose, onEdit, onRefresh }) => {
  const [updating, setUpdating] = useState(false);

  const getFullImageUrl = (url) => {
    if (!url) return '';
    if (url.startsWith('http')) return url;
    if (url.startsWith('/uploads')) return `https://inteliheads.in${url}`;
    return url;
  };

  const handleToggleStatus = async () => {
    setUpdating(true);
    try {
      await toggleProductStatus(product._id);
      toast.success(`Product ${product.isActive ? 'deactivated' : 'activated'} successfully`);
      onRefresh();
      onClose();
    } catch (error) {
      toast.error('Error toggling product status');
    } finally {
      setUpdating(false);
    }
  };

  const handleDelete = async () => {
    if (window.confirm('Are you sure you want to delete this product? This action cannot be undone.')) {
      setUpdating(true);
      try {
        await deleteProduct(product._id);
        toast.success('Product deleted successfully');
        onRefresh();
        onClose();
      } catch (error) {
        toast.error('Error deleting product');
      } finally {
        setUpdating(false);
      }
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }} onClick={onClose}>
      <div style={{
        background: 'white',
        borderRadius: '16px',
        maxWidth: '800px',
        width: '90%',
        maxHeight: '85vh',
        overflow: 'auto',
        animation: 'slideInUp 0.3s ease'
      }} onClick={(e) => e.stopPropagation()}>
        
        {/* Header */}
        <div style={{
          background: 'linear-gradient(135deg, #0A192F 0%, #1E3A5F 100%)',
          padding: '1.5rem',
          color: 'white',
          position: 'relative'
        }}>
          <button onClick={onClose} style={{
            position: 'absolute',
            top: '1rem',
            right: '1rem',
            background: 'rgba(255,255,255,0.2)',
            border: 'none',
            borderRadius: '50%',
            width: '32px',
            height: '32px',
            cursor: 'pointer',
            color: 'white',
            fontSize: '1rem'
          }}>×</button>
          <h2 style={{ marginBottom: '0.25rem' }}>Product Details</h2>
          <p style={{ opacity: 0.8, fontSize: '0.85rem' }}>View and manage product information</p>
        </div>
        
        {/* Content */}
        <div style={{ padding: '1.5rem' }}>
          {/* Product Image */}
          {product.imageUrl && (
            <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
              <img 
                src={getFullImageUrl(product.imageUrl)} 
                alt={product.name}
                style={{ maxWidth: '100%', maxHeight: '200px', objectFit: 'contain', borderRadius: '8px' }}
              />
            </div>
          )}
          
          {/* Product Info Grid */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '1rem',
            marginBottom: '1.5rem'
          }}>
            <div style={{ background: '#F7F9FC', padding: '1rem', borderRadius: '8px' }}>
              <label style={{ fontSize: '0.7rem', color: '#5A6E7F', textTransform: 'uppercase', letterSpacing: '1px' }}>Product Name</label>
              <div style={{ fontSize: '1rem', fontWeight: 600, color: '#0A192F', marginTop: '0.25rem' }}>{product.name}</div>
            </div>
            
            <div style={{ background: '#F7F9FC', padding: '1rem', borderRadius: '8px' }}>
              <label style={{ fontSize: '0.7rem', color: '#5A6E7F', textTransform: 'uppercase', letterSpacing: '1px' }}>Category</label>
              <div style={{ marginTop: '0.25rem' }}>
                <span style={{ background: '#E3F2FD', padding: '0.2rem 0.6rem', borderRadius: '20px', fontSize: '0.8rem' }}>{product.category}</span>
              </div>
            </div>
            
            <div style={{ background: '#F7F9FC', padding: '1rem', borderRadius: '8px' }}>
              <label style={{ fontSize: '0.7rem', color: '#5A6E7F', textTransform: 'uppercase', letterSpacing: '1px' }}>Price</label>
              <div style={{ fontSize: '1.2rem', fontWeight: 700, color: '#2C7A7B', marginTop: '0.25rem' }}>{product.price}</div>
            </div>
            
            <div style={{ background: '#F7F9FC', padding: '1rem', borderRadius: '8px' }}>
              <label style={{ fontSize: '0.7rem', color: '#5A6E7F', textTransform: 'uppercase', letterSpacing: '1px' }}>Stock</label>
              <div style={{ fontSize: '1rem', fontWeight: 600, color: '#0A192F', marginTop: '0.25rem' }}>{product.stock} units</div>
            </div>
            
            <div style={{ background: '#F7F9FC', padding: '1rem', borderRadius: '8px' }}>
              <label style={{ fontSize: '0.7rem', color: '#5A6E7F', textTransform: 'uppercase', letterSpacing: '1px' }}>Status</label>
              <div style={{ marginTop: '0.25rem' }}>
                <span style={{
                  padding: '0.25rem 0.75rem',
                  borderRadius: '20px',
                  background: product.isActive ? '#D4EDDA' : '#F8D7DA',
                  color: product.isActive ? '#155724' : '#721C24',
                  fontSize: '0.8rem'
                }}>
                  {product.isActive ? 'Active' : 'Inactive'}
                </span>
              </div>
            </div>
            
            <div style={{ background: '#F7F9FC', padding: '1rem', borderRadius: '8px' }}>
              <label style={{ fontSize: '0.7rem', color: '#5A6E7F', textTransform: 'uppercase', letterSpacing: '1px' }}>Display Order</label>
              <div style={{ fontSize: '1rem', fontWeight: 600, color: '#0A192F', marginTop: '0.25rem' }}>{product.order || 0}</div>
            </div>
          </div>
          
          {/* Description */}
          {product.description && (
            <div style={{ marginBottom: '1.5rem' }}>
              <h3 style={{ fontSize: '1rem', marginBottom: '0.5rem', color: '#0A192F' }}>Description</h3>
              <p style={{ color: '#5A6E7F', lineHeight: '1.6' }}>{product.description}</p>
            </div>
          )}
          
          {/* Features */}
          {product.features && product.features.length > 0 && (
            <div style={{ marginBottom: '1.5rem' }}>
              <h3 style={{ fontSize: '1rem', marginBottom: '0.5rem', color: '#0A192F' }}>Key Features</h3>
              <ul style={{ margin: 0, paddingLeft: '1.2rem' }}>
                {product.features.map((feature, idx) => (
                  <li key={idx} style={{ color: '#5A6E7F', marginBottom: '0.5rem' }}>{feature}</li>
                ))}
              </ul>
            </div>
          )}
          
          {/* Metadata */}
          <div style={{
            background: '#F7F9FC',
            padding: '1rem',
            borderRadius: '8px',
            fontSize: '0.7rem',
            color: '#94A3B8',
            marginBottom: '1.5rem'
          }}>
            <div>Created: {new Date(product.createdAt).toLocaleString()}</div>
            <div>Last Updated: {new Date(product.updatedAt).toLocaleString()}</div>
            <div>ID: {product._id}</div>
          </div>
          
          {/* Action Buttons */}
          <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
            <button
              onClick={onEdit}
              disabled={updating}
              style={{
                flex: 1,
                padding: '0.75rem',
                background: '#2C7A7B',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem',
                fontWeight: 500
              }}
            >
              <i className="fas fa-edit"></i> Edit Product
            </button>
            
            <button
              onClick={handleToggleStatus}
              disabled={updating}
              style={{
                flex: 1,
                padding: '0.75rem',
                background: product.isActive ? '#F5A623' : '#10B981',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem',
                fontWeight: 500
              }}
            >
              <i className={`fas fa-${product.isActive ? 'pause' : 'play'}`}></i>
              {product.isActive ? 'Deactivate' : 'Activate'}
            </button>
            
            <button
              onClick={handleDelete}
              disabled={updating}
              style={{
                flex: 1,
                padding: '0.75rem',
                background: '#DC2626',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem',
                fontWeight: 500
              }}
            >
              <i className="fas fa-trash"></i> Delete Product
            </button>
          </div>
        </div>
      </div>
      
      <style>{`
        @keyframes slideInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default ProductDetails;